<template>
  <div>
    <b-modal
      id="review"
      ref="my-modal"
      centered
      size="lg"
      hide-header
      hide-footer
    >
      <div class="row m-0">
        <div class="col-lg-6 p-0">
          <div class="order-compliment">
            <BrandLogo></BrandLogo>
            <ThankYou></ThankYou>
            <!-- <Cashback></Cashback> -->
            <OrderInfo></OrderInfo>
          </div>
        </div>
        <div class="col-lg-6 p-0">
          <Rating @close="hideModal"></Rating>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BrandLogo from './BrandLogo'
import ThankYou from './ThankYou'
// import Cashback from './Cashback'
import OrderInfo from './OrderInfo'
import Rating from './Rating'
export default {
  components: {
    BrandLogo,
    ThankYou,
    // Cashback,
    OrderInfo,
    Rating,
  },
  methods: {
    showModal() {
      // we will work on it later
      // this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
  },
  mounted() {
    this.showModal()
  },
}
</script>

<style lang="scss">
#review {
  .modal-lg {
    .modal-content {
      overflow: hidden;
      border-radius: $px20;
      .modal-body {
        padding: 0;
      }
    }
  }
  .order-compliment {
    padding: calc(#{$px30} + (64 - 30) * ((100vw - #{$px320}) / (1920 - 320)))
      calc(#{$px20} + (33 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
      calc(#{$px40} + (50 - 40) * ((100vw - #{$px320}) / (1920 - 320)));
    background: $light-border;
    height: 100%;
  }
  @media (min-width: 992px) {
    .modal-lg {
      max-width: $px986;
    }
  }
  @media (max-width: 575px) {
    .modal-dialog {
      margin: 0;
      transition: none !important;
      transform: none !important;
      .modal-content {
        border-radius: 0;
        border: none;
        h5 {
          margin-bottom: calc(
            #{$px15} + (20 - 15) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
        .order-compliment {
          background-color: $white;
          border-bottom: $px1 solid $light-border;
          svg {
            display: none;
          }
          ul {
            li {
              .media {
                .order-data {
                  transform: scale(0.8);
                }
                .media-body {
                  h5 {
                    font-size: $px14;
                  }
                  h6 {
                    margin-bottom: -$px2;
                  }
                }
              }
              &:first-child {
                width: auto !important;
                padding-right: $px20 !important;
              }
            }
          }
          .cashback-offer {
            border-bottom-style: dashed;
            .media {
              background-color: rgba(var(--color-warning-color-source), 0.06);
              p {
                color: $warning-color;
              }
            }
          }
          .succesfull-order {
            text-align: center;
          }
        }
        .satisfied {
          .btns-full {
            border-top: $px1 solid $light-border;
            padding-top: $px15;
            li {
              &:first-child {
                display: none;
              }
              + li {
                margin-left: 0;
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 360px) {
    .order-compliment {
      ul {
        display: block;
        li {
          display: block;
          &:first-child {
            padding-right: 0 !important;
            margin-bottom: $px15;
          }
        }
      }
    }
  }
}
</style>
